// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2yM2W","content":"styles_content__lZG9d","row":"styles_row__3AqUl","footer":"styles_footer__2yveM","phraseLength":"styles_phraseLength__fpEGb"};